import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import {
  ConductivityprofileElementsViewModel,
  ConductivityprofileImport,
  Conductivityprofiles,
  ListConductivityprofiles,
} from 'src/app/models/conductivityprofiles.model';

@Injectable({
  providedIn: 'root',
})
export class ConductivityprofilesService {
  gnBaseURL: any;

    //get plantId from breadcrumbs
    private plantIdSource = new BehaviorSubject<number | null>(null);
    plantId$ = this.plantIdSource.asObservable();
  
    setPlantId(plantId: number) {
      this.plantIdSource.next(plantId);
    }
    //get trainid from breadcrumbs
    private trainIdSource = new BehaviorSubject<number | null>(null);
    trainId$ = this.trainIdSource.asObservable();
  
    setTrainId(trainId: number) {
      this.trainIdSource.next(trainId);
    }
  
  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }

  getConductivityprofilesById(
    id: string
  ): Observable<ListConductivityprofiles> {
    return this.http.get<ListConductivityprofiles>(
      this.gnBaseURL + 'ConductivityProfile/GetConductivityProfileById/' + id
    );
  }

  getAllConductivityprofiles(): Observable<ListConductivityprofiles[]> {
    return this.http.get<ListConductivityprofiles[]>(
      this.gnBaseURL + 'Conductivityprofile/GetConductivityProfileList'
    );
  }

  getConductivityprofilesListByTrainId(id: string) {
    return this.http.get<ListConductivityprofiles[]>(
      this.gnBaseURL +
        'ConductivityProfile/GetConductivityprofileByTrainId/' +
        id
    );
  }
  getdistinctDatesOfConductivityprofileByTrainId(id: string) {
    return this.http.get<ListConductivityprofiles[]>(
      this.gnBaseURL +
        'ConductivityProfile/GetdistinctDatesOfConductivityprofileByTrainId/' +
        id
    );
  }

  addConductivityprofiles(
    conductivitydetails: ConductivityprofileElementsViewModel[]
  ) {
    return this.http.post<Conductivityprofiles>(
      this.gnBaseURL + 'ConductivityProfile/AddConductivityProfileDetails',
      conductivitydetails
    );
  }

  updateConductivityprofiles(
    id: number,
    model: ListConductivityprofiles
  ): Observable<ListConductivityprofiles> {
    return this.http.post<ListConductivityprofiles>(
      this.gnBaseURL + 'ConductivityProfile/EditConductivityProfile/' + id,
      model
    );
  }

  deleteConductivityprofiles(Id: number) {
    return this.http.get(
      this.gnBaseURL + 'ConductivityProfile/' + Id + '/action/delete'
    );
  }

  deleteConductivityprofilesByTrainId(Id: number) {
    return this.http.get(
      this.gnBaseURL +
        'ConductivityProfile/DeleteConductivityProfileByTrainId/' +
        Id +
        '/action/delete'
    );
  }

  importConductivityprofile(ConductivityprofileImportModel, selectedFile) {
    const formData = new FormData();
    formData.append('model', JSON.stringify(ConductivityprofileImportModel));
    formData.append(selectedFile.name, selectedFile);
    console.log(formData);
    return this.http.post<ConductivityprofileImport>(
      this.gnBaseURL + 'ConductivityProfile/conductivityprofileimport',
      formData
    );
  }
}
